<template>
    <div class="promoted-profiles">
        <div class="container">

            <div class="row promoted-profiles-limit-profile-page-width">

                <div class="col-md-12">

                    <div class="row mt-3">
                        <div class="col-md-12">
                            <span class="heading-1">{{ translate.product.promotedProfiles }}</span>
                        </div>
                    </div>

                    <div class="row mb-5">

                        <div v-for="user in promotedProfiles" :key="user.id" class="col-4 col-md-2 mt-3 profile-block">


                            <div class="promoted-profile-block-head">
                                <span class="profile-block-images-new-banner">{{ translate.product.gold }}</span>
                            </div>


                            <a :href="regionRelativeUrl(user.profile_path)" @click.prevent="onLinkClick(user)">
                                    <span class="profile-block-images">

                                        <img v-if="showExplicitPlaceholder(user)" class="lozad" :data-src="getExplicitPlaceholderUrl(user)" ref="photo"/>

                                        <picture v-else class="lozad lazyload-img"
                                                 :data-iesrc="getPhotoUrl(user,'jpg','medium')">

                                            <source :srcset="getPhotoSrcSet(user,'webp')"
                                                    class="lazyload-src" type="image/webp">
                                            <source :srcset="getPhotoSrcSet(user,'jpg')"
                                                    class="lazyload-src" type="image/jpeg">

                                            <!-- SEO: keep src="" EMPTY. Real src here (commit 528f2648) exposed ~30 photos/page to Googlebot-Image and killed SERP SEO — see CLAUDE.md "SEO Hard Rules". -->
                                            <noscript>
                                                <img src="" class="lazyload-img lazyload-noscript" :style="'  background: url(' +
                                                     getPhotoUrl(user,'jpg','medium') +') no-repeat;'" alt="">
                                            </noscript>
                                        </picture>

                                    </span>
                            </a>
                            <span class="profile-block-details">
                                    <span class="profile-details">
                                        <div class="details-first-row d-flex">
                                            <span class="heading-1">{{ user.username }}</span>
                                            <span class="flex-shrink-0 flex-grow-0">{{ getUserAge(user, ', ') }}</span>
                                        </div>
                                        <span class="text-ellipsis">{{ getUserLocationForSearch(user) }}</span>
                                    </span>
                                </span>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import userMixin from "@/components/mixins/userMixin";
import photoMixin from "@/components/mixins/photoMixin";
import lazyLoadImg from "@/components/mixins/lazyLoadImg";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";

function showExplicitPlaceholder(user) {
    return _.get(user, `photos_data.0.explicit`, false);
}

function getExplicitPlaceholderUrl() {
    return constants.user_photo.EXPLICIT_PHOTO_PLACEHOLDER;
}

function onLinkClick(user) {
    if (!_.isEqual(this.$route.fullPath, user.profile_path)) {

        // set the current promoted on profile results id
        // it will be used in case if user clicks on any of the the promoted profiles
        if (this.promotedOnProfileResultsId && typeof xt != 'undefined') {
            xt.setId('pop', this.promotedOnProfileResultsId);
        }

        this.$router.push({path: user.profile_path});
        this.$emit('on-profile-click', user);
    }
}

export default {
    mounted() {
        this.initLazyLoading();
    },
    mixins: [
        userMixin,
        photoMixin,
        lazyLoadImg,
        regionsUrlMixin,
    ],
    methods: {
        showExplicitPlaceholder,
        getExplicitPlaceholderUrl,
        onLinkClick,
    },
    computed: {
        ...mapState([
            'translate'
        ]),
    },
    props: {
        promotedProfiles: {
            type: Array,
            default: []
        },
        promotedOnProfileResultsId: {
            type: String,
            default: null
        }
    }
}
</script>